const SkillIcon = () => {
  return (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.5 22.5H16.5V3H22.5V22.5ZM18 21H21V4.5H18V21ZM15 22.5H9V9H15V22.5ZM10.5 21H13.5V10.5H10.5V21ZM7.5 22.5H1.5V13.5H7.5V22.5Z" fill="currentColor"/>
</svg>
  )
}

export default SkillIcon